// extracted by mini-css-extract-plugin
module.exports = {"info":"voice-info_info__CNiUz","voice_info":"voice-info_voice_info__xHfgc","artist_text":"voice-info_artist_text__VIcy9","play_icon":"voice-info_play_icon__r7IcS"};